export default __webpack_public_path__ + "static/media/LogoQualiopiActionsdeFormation.1efdcc54.png";